import * as PIXI from 'pixi.js'
import Tool from './tool.class'
import { destroy } from '../utils'

export default class Magnifier extends Tool {
  update(event, config, container, pixiObj, options) {
    super.update(...arguments)
    event && this.drawMagnifier(event.offsetX, event.offsetY)
  }
  mouseMove(event) {
    this.drawMagnifier(event.offsetX, event.offsetY)
  }
  drawMagnifier(x, y) {
    const baseLayer = this.pixiObj.stage.getChildByName('BASE_LAYER')
    if (!baseLayer) return
    this.container.removeChildren().forEach(i => {
      // destory object from webgl except base layer
      i.name !== 'base' && destroy(i)
    })
    const bg = PIXI.Sprite.from(baseLayer.texture)
    // TODO: 渲染后的超级慢
    // this.pixiObj.renderer.extract.base64()
    // const bg = PIXI.Sprite.from(this.pixiObj.view)
    bg.name = 'base'

    x = (x / this.options.width) * 1920
    y = (y / this.options.height) * 1080
    const scale = this.config.diameter
    bg.width = bg.width * scale
    bg.height = bg.height * scale
    bg.x = x * -(scale - 1)
    bg.y = y * -(scale - 1)
    let magnifierMask = new PIXI.Graphics()
    magnifierMask.beginFill(0)
    magnifierMask.drawCircle(0, 0, 160)
    magnifierMask.endFill()
    magnifierMask.x = x
    magnifierMask.y = y
    bg.mask = magnifierMask
    let magnifierFrame = new PIXI.Graphics()
    magnifierFrame.lineStyle(4, 0x969696, 1)
    magnifierFrame.beginFill(0, 0)
    magnifierFrame.drawCircle(0, 0, 160)
    magnifierFrame.endFill()
    magnifierFrame.x = x
    magnifierFrame.y = y
    this.container.addChild(bg)
    this.container.addChild(magnifierMask)
    this.container.addChild(magnifierFrame)
  }
}
